import { isNullish } from '@witmetrics/utils/misc';
import { formatNumber } from '@witmetrics/utils/strings';
import { DIALOGS } from '@witmetrics/unison-core';
import { useAppState } from '@/providers/AppStateProvider';
import Spinner from '@/components/Spinner';
import Tooltip from '@/components/Tooltip';
import { CreditsIcon } from '@/icons';
import { classes } from './utils';

export type TokenCountProps = {
  pending?: boolean;
  insufficient?: boolean;
  count: number;
  availableBalance?: number | null;
};

export default function TokenCount({
  pending,
  insufficient,
  count,
  availableBalance,
}: TokenCountProps) {
  const { onOpenDialog } = useAppState();

  const handleOpen = () => onOpenDialog(DIALOGS.CREDITS);

  return (
    <Tooltip arrow enterDelay={0} placement="bottom" title="Credits">
      <button
        className={insufficient ? classes.countInsufficient : classes.count}
        onClick={handleOpen}>
        <CreditsIcon className={classes.icon} />
        {pending ? (
          <Spinner size={24} />
        ) : (
          <>
            <span className={classes.value}>{formatNumber(count)}</span>
            {!isNullish(availableBalance) && (
              <span className={classes.available}>
                / {formatNumber(availableBalance)}
              </span>
            )}
          </>
        )}
      </button>
    </Tooltip>
  );
}
